import { render, staticRenderFns } from "./Idea4.vue?vue&type=template&id=b1e88e4e"
import script from "./Idea4.vue?vue&type=script&lang=js"
export * from "./Idea4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports